import type { AxiosError } from 'axios'
import toast from 'react-hot-toast'

import type { DefaultApiResponse } from '~/types/default'

const useHandleError = () => {
  return (error: AxiosError<DefaultApiResponse>) => {
    if (error.response) {
      if (error.response.data.msg) {
        toast.error(error.response.data.msg)
      } else {
        const message = error.response.data.message
        if (Array.isArray(message)) {
          toast.error(message[0])
        } else {
          toast.error(message)
        }
      }
    }
  }
}

export default useHandleError
